module.exports = __webpack_public_path__ + "media/images/new-ui-images/analytics-icon-97a89bc0289f7cb15a1a00863e8ba9ae.svg";